<!-- 备选队员参赛项目 -->
<template>
  <div>
    <p class="title">
      备选队员 <a-button style="float: right;" icon="plus" type="primary" @click="deit()">编辑预参赛队员</a-button>
    </p>
    <div class="sticky">
      <div class="playerDiv">
        <span
          :style="getTopSpanStyle('boy')"
          v-if="this.choiceCombatDetail == null || this.choiceCombatDetail.sex === 0 || this.choiceCombatDetail.sex === 1">
          <a-empty :image="emptyUser" v-if="upShowPlayers('boy').length === 0" :image-style="{ height: '80px'}">
            <div style="text-align: center; color: gray;" slot="description"> 暂无匹配的队员信息 </div>
          </a-empty>
          <span>
            <div class="player" v-for="(player, index) in upShowPlayers('boy')" :key="index" :title="player.name + upChoicePlayerIndex" @click="upChoicePlayer(player, player['pIndex'] || index)">
              <img class="head" :src="player.head || defaultHead">
<!--              <img class="checked" v-if="upChoicePlayerIndex.indexOf(player['pIndex'] || index) > -1" :src="imgCheck">-->
              <img class="checked" v-if="upChoicePlayerCardId.indexOf(player.cardId || index) > -1" :src="imgCheck">
              <p>{{ player.name }}</p>
            </div>
          </span>
        </span>
        <span
          :style="getTopSpanStyle('girl')"
          v-if="this.choiceCombatDetail != null && (this.choiceCombatDetail.sex === 0 || this.choiceCombatDetail.sex === 2)">
          <a-empty :image="emptyUser" v-if="upShowPlayers('girl').length === 0" :image-style="{ height: '80px'}">
            <div style="text-align: center; color: gray;" slot="description"> 暂无匹配的队员信息 </div>
          </a-empty>
          <span>
            <div class="player" v-for="(player, index) in upShowPlayers('girl')" :key="index" :title="player.name + upChoicePlayerIndex" @click="upChoicePlayer(player, player['pIndex'] || index)">
              <img class="head" :src="player.head || defaultHead">
<!--              <img class="checked" v-if="upChoicePlayerIndex.indexOf(player['pIndex'] || index) > -1" :src="imgCheck">-->
              <img class="checked" v-if="upChoicePlayerCardId.indexOf(player.cardId || index) > -1" :src="imgCheck">
              <p>{{ player.name }}</p>
            </div>
          </span>
        </span>
        <span
          :style="getTopSpanStyle('young')"
          v-if="this.choiceCombatDetail != null && this.choiceCombatDetail.youndData.youngSex != null">
          <a-empty :image="emptyUser" v-if="upShowPlayers('young').length === 0" :image-style="{ height: '80px'}">
            <div style="text-align: center; color: gray;" slot="description"> 暂无匹配的队员信息 </div>
          </a-empty>
          <span>
            <div class="player" v-for="(player, index) in upShowPlayers('young')" :key="index" :title="player.name + upChoicePlayerIndex" @click="upChoicePlayer(player, player['pIndex'] || index)">
              <img class="head" :src="player.head || defaultHead">
<!--              <img class="checked" v-if="upChoicePlayerIndex.indexOf(player['pIndex'] || index) > -1" :src="imgCheck">-->
              <img class="checked" v-if="upChoicePlayerCardId.indexOf(player.cardId || index) > -1" :src="imgCheck">
              <p>{{ player.name }}</p>
            </div>
          </span>
        </span>
      </div>
      <div class="opertaionDiv">
      </div>
    </div>
    <a-spin :spinning="loading">
      <p class="title">
        参赛项目
      </p>
      <a-alert :message="getCombatDetailAlert()" banner v-if="choiceCombatDetail != null"/>
      <div class="combatDiv">
        <div class="subItem" v-for="(item, index) in combatDetails" :key="index">
          <div class="leftCell" @click="clickCombatDetail(item)">
            <div :class="choiceCombatDetail != null && item.combatDetailId === choiceCombatDetail.combatDetailId ? 'combatName active' : 'combatName default'">{{ item.fullName }}</div>
          </div>
          <div class="rightCell">
            <div class="playerContainer">
              <!-- 团队项目队员信息 -->
              <a-badge
                :count="(teamIndex + 1) + '队'"
                :number-style="{
                  backgroundColor: 'rgb(218, 218, 218)',
                }"
                v-if="item.identity !== 1 && item.identity !== 2"
                v-for="(team, teamIndex) in item['team']"
                :key="teamIndex"
                @click="teamClick(teamIndex)">
                <div :class="(choiceCombatDetail != null && item.combatDetailId === choiceCombatDetail.combatDetailId && teamIndex === choiceCombatTeamIndex) ? 'teamContainer curTeam left20' : 'teamContainer left20'">
                  <div :class="pIndex === 0 ? 'teamPlayer' : 'teamPlayer left10'" v-for="(p, pIndex) in team" :key="pIndex">
                    <img class="head" :src="p == null ? defaultHead : p.head">
                    <img class="checked" v-if="false" :src="imgCheck">
                    <p>{{ p == null ? '待选择' : p.name }}</p>
                  </div>
                </div>
              </a-badge>
              <!-- 团队项目添加队伍 -->
              <div
                class="player"
                style="margin-top: 10px;cursor:pointer;"
                v-if="addShow(item)"
                @click="addTeam(item)">
                <img class="head" :src="addBackground">
                <p class="add">添加小队</p>
              </div>

              <!-- 单人项目队员信息 -->
              <div class="player"
                 v-if="item.identity === 1 || item.identity === 2"
                 v-for="(player, playerIndex) in item['players'] || []"
                 :key="playerIndex"
                 @click="downChoicePlayer(player)">
                <img class="head" :src="player.head || defaultHead">
                <img class="checked" v-if="false" :src="imgCheck">
                <p style="margin-bottom: 0px;">{{ player.name }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="btnContent" >
          <div class="btn top20 right20" @click="submit()">提交</div>
        </div>
      </div>
    </a-spin>
    <AddEnclosure ref="addEnclosure" @jump="jump" @enclosureSuccess="enclosureSuccess"></AddEnclosure>
  </div>
</template>
<script>
import AddEnclosure from '../enclosure/AddEnclosure'
import matchFun from '@comm/utils/matchFun'
import store from '@/store'
import { mapState } from 'vuex'
export default {
  components: {
    AddEnclosure
  },
  props: {
    choicedPlayers: {
      type: Array,
      default: () => { return [] }
    },
    combatDetailGroup: {
      type: Object,
      default: null
    }
  },
  computed: {
    ...mapState({
      coachId: state => state.join.coachId
    })
  },
  data () {
    return {
      loading: false,
      matchFun: matchFun,
      emptyUser: require('@comm/assets/join/empty_user.png'),
      addBackground: require('@comm/assets/join/add_bg.jpg'),
      defaultHead: require('@comm/assets/join/photo.png'),
      imgCheck: require('@comm/assets/join/imgCheck.png'),
      arrowWhite: require('@comm/assets/join/next.png'),
      arrowRed: require('@comm/assets/join/arrow_red.png'),
      del: require('@comm/assets/join/del.png'),
      edit: require('@comm/assets/join/edit.png'),
      matchId: this.$route.query.matchId,
      combatDetails: [],
      choiceCombatDetail: null, // 当前点击选择的项目
      choiceCombatTeamIndex: 0, // 团队项目当前操作的队伍下标
      upChoicePlayerIndex: [],
      upChoicePlayerCardId: [], // 备选队员中已经选择了的队员id
      choicePlayerIndex: [], // 当前选择的队员下标
      combatTerm: [], // 项目兼项数据情况
      allChoicedCardIds: [] // 所有选择了项目的队员cardId集合
    }
  },
  mounted () {
    this.queryCombatDetailNameByTitle()
    // 查询兼项配置
    this.queryCombatTerm()
  },
  methods: {
    resetData () {
      this.combatDetails = []
      this.choiceCombatDetail = null
      this.choiceCombatTeamIndex = 0
      this.upChoicePlayerIndex = []
      this.upChoicePlayerCardId = []
      this.choicePlayerIndex = []
      this.combatTerm = []
      this.allChoicedCardIds = []
    },
    // 中间编辑按钮
    deit () {
      this.$emit('lastStep')
    },
    // 过滤获取上部分应该展示的队员信息
    upShowPlayers (type) {
      if (this.choiceCombatDetail == null) {
        return this.choicedPlayers
      } else {
        let minAge = Date.parse(this.choiceCombatDetail.minAge) // 项目最小年龄限制
        let maxAge = Date.parse(this.choiceCombatDetail.maxAge) // 项目最大年龄限制
        let sex = this.choiceCombatDetail.sex // 项目性别限制 1：男 2：女 0：无限制
        let youngMinAge = Date.parse(this.choiceCombatDetail.youndData.youngMinAge) // 项目以小打大小最小年龄限制
        let youngMaxAge = Date.parse(this.choiceCombatDetail.youndData.youngMaxAge) // 项目以小打大小最大年龄限制
        let youngSex = this.choiceCombatDetail.youndData.youngSex // 项目以小打大小性别限制
        return this.choicedPlayers.filter((player, pIndex) => {
          let playerBirthday = Date.parse(player.birthday)
          if (type === 'boy') {
            if (playerBirthday >= minAge && playerBirthday <= maxAge && player.sex === 1) {
              player['pIndex'] = pIndex
              return player
            }
          } else if (type === 'girl') {
            if (playerBirthday >= minAge && playerBirthday <= maxAge && player.sex === 2) {
              player['pIndex'] = pIndex
              return player
            }
          } else {
            if (playerBirthday >= youngMinAge && playerBirthday <= youngMaxAge && (sex === 0 || (player.sex === youngSex))) {
              player['pIndex'] = pIndex
              return player
            }
          }
        })
      }
    },
    // 根据选择的组别名称查询项目信息
    queryCombatDetailNameByTitle () {
      this.loading = true
      if (this.combatDetailGroup == null) {
        return
      }
      let agencyId = this.$route.query.agencyId
      let teamId = this.$route.query.teamId
      this.combatDetails = []
      this.$api.match.queryCombatDetailNameByTitle(this.matchId, agencyId, teamId, this.combatDetailGroup.name).then(res => {
        if (res.status === 0) {
          this.combatDetails = res.data
          // 循环获取所有的已选择的队员cardId
          this.combatDetails.forEach(combat => {
            if (combat.identity > 2) {
              // 团队
              let teams = combat['team'] || []
              if (teams.length > 0) {
                let maxNumber = combat.maxNumber
                teams.forEach(t => {
                  if (t.length < maxNumber) {
                    if (t.length < maxNumber) {
                      for (let i = 0; i <= maxNumber - t.length; i++) {
                        t.push(null)
                      }
                    }
                  }
                })
                combat['hasSignData'] = true
              } else {
                combat['hasSignData'] = false
              }
              let cardIdAry = []
              teams.forEach(team => {
                team.forEach(p => {
                  if (p != null) {
                    cardIdAry.push(p.cardId)
                    this.allChoicedCardIds.push(p.cardId)
                  }
                })
              })
              let cpIndex = []
              let cpCardId = []
              this.choicedPlayers.forEach((item, index) => {
                if (cardIdAry.indexOf(item.cardId) > -1) {
                  cpIndex.push(index)
                  cpCardId.push(item.cardId)
                }
              })
              if (cpIndex.length > 0) {
                combat['upChoicePlayerIndex'] = cpIndex
                combat['upChoicePlayerCardId'] = cpCardId
              }
            } else {
              let players = combat['players'] || []
              if (players.length > 0) {
                combat['hasSignData'] = true
              } else {
                combat['hasSignData'] = false
              }
              let cardIdAry = []
              players.forEach(p => {
                cardIdAry.push(p.cardId)
                this.allChoicedCardIds.push(p.cardId)
              })
              let cpIndex = []
              this.choicedPlayers.forEach((item, index) => {
                if (cardIdAry.indexOf(item.cardId) > -1) {
                  cpIndex.push(index)
                }
              })
              if (cpIndex.length > 0) {
                combat['upChoicePlayerIndex'] = cpIndex
              }
            }
          })
        } else {
          this.$message.error(res.msg)
        }
        store.commit('join/JOIN_ALL_CHOICED_CARD_IDS', this.allChoicedCardIds)
      }).catch(err => {
        console.log('err', err)
        this.$message.error('项目查询失败')
      }).finally(_ => {
        this.loading = false
      })
    },
    // 选择参赛队员
    upChoicePlayer (player, index) {
      if (this.choiceCombatDetail == null) {
        this.$message.error('请先选择一个要参赛的项目')
        return
      }
      // 获取当前选择的项目的类型
      let identity = this.choiceCombatDetail.identity
      this.upChoicePlayerIndex = this.choiceCombatDetail['upChoicePlayerIndex'] || []
      this.upChoicePlayerCardId = this.choiceCombatDetail['upChoicePlayerCardId'] || []
      let cIndex = this.upChoicePlayerIndex.indexOf(index)
      if (cIndex > -1) {
        this.upChoicePlayerIndex.splice(cIndex, 1)
        let cardId = player.cardId
        let pIndex = this.allChoicedCardIds.indexOf(cardId)
        if (pIndex > -1) {
          this.allChoicedCardIds.splice(pIndex, 1)
        }
        let cardIdIndex = this.upChoicePlayerCardId.indexOf(cardId)
        if (cardIdIndex > -1) {
          this.upChoicePlayerCardId.splice(cardIdIndex, 1)
        }
      } else {
        let result = this.verifyCombatTerm(player)
        if (!result) {
          return
        }
        if (identity !== 1 && identity !== 2) {
          // 判断当前选中的队伍是否有空位置
          let team = this.choiceCombatDetail['team'] || []
          let players = team[this.choiceCombatTeamIndex] || []
          if (players.length > 0) {
            let hasNull = players.some(p => p == null)
            if (!hasNull) {
              this.resetChoiceCombatTeamIndex()
            }
          }
          // 小队最大数量
          let teamLimit = this.choiceCombatDetail.teamLimit || 20
          if (teamLimit != -1 && this.choiceCombatTeamIndex >= teamLimit) {
            this.$message.error('小队数量已满')
            return
          }
          // 如果是混双，需要判断队员性别是否匹配
          if (identity === 3) {
            let team = this.choiceCombatDetail['team'] || []
            let players = team[this.choiceCombatTeamIndex] || []
            let hasSameSex = players.some(p => (p != null && p.sex == player.sex))
            if (hasSameSex) {
              this.$message.error('性别不匹配')
              return
            }
          }
        }
        this.upChoicePlayerIndex.push(index)
        this.upChoicePlayerCardId.push(player.cardId)
        this.allChoicedCardIds.push(player.cardId)
      }
      this.choiceCombatDetail['upChoicePlayerIndex'] = this.upChoicePlayerIndex
      if (identity === 1 || identity === 2) {
        this.operSignCombat()
      } else {
        this.operTeamCombat(player, cIndex)
      }
      store.commit('join/JOIN_ALL_CHOICED_CARD_IDS', this.allChoicedCardIds)
    },
    // 单人项目
    operSignCombat () {
      // 如果是单人项目
      this.choiceCombatDetail['players'] = this.getToDownPlayers()
    },
    // 普通团体不分团体
    operTeamCombat (player, cIndex) {
      // 团队最大人数
      let maxNumber = this.choiceCombatDetail.maxNumber
      // 创建一个以最大人数为size的空数组
      let emptyPlayer = []
      for (let i = 0; i < maxNumber; i++) {
        emptyPlayer.push(null)
      }
      // 如果是团队项目
      let combatDetailTeam = this.choiceCombatDetail['team'] || []
      let teamPlayers = combatDetailTeam[this.choiceCombatTeamIndex] || emptyPlayer
      // 判断是增加还是删除
      let operType = cIndex > -1 ? 'del' : 'add'
      if (operType === 'add') {
        for (let i = 0; i < teamPlayers.length; i++) {
          let tp = teamPlayers[i]
          if (tp == null) {
            if (cIndex > -1) {
              let cardId = player.cardId
              if (tp.cardId === cardId) {
                teamPlayers[i] = null
              }
            } else {
              teamPlayers[i] = player
            }
            break
          }
        }
        combatDetailTeam[this.choiceCombatTeamIndex] = teamPlayers
        this.choiceCombatDetail['team'] = combatDetailTeam
        // 赋值完成，获取下一个要操作的队伍下标，该下标需要大于或等于当前下标，只有当当前操作的下标为最大值时，才从头重新取一次下标
        let hasNull = false
        for (let i = this.choiceCombatTeamIndex; i < combatDetailTeam.length; i++) {
          let team = combatDetailTeam[i]
          for (let j = 0; j < team.length; j++) {
            let p = team[j]
            if (p == null) {
              this.choiceCombatTeamIndex = i
              hasNull = true
              break
            }
          }
          if (hasNull) {
            break
          }
        }
        if (!hasNull) {
          this.choiceCombatTeamIndex = combatDetailTeam.length
          for (let i = 0; i < this.choiceCombatTeamIndex; i++) {
            let team = combatDetailTeam[i]
            for (let j = 0; j < team.length; j++) {
              let p = team[j]
              if (p == null) {
                hasNull = true
                this.choiceCombatTeamIndex = i
                break
              }
            }
            if (hasNull) {
              break
            }
          }
        }
      } else {
        for (let i = 0; i < combatDetailTeam.length; i++) {
          let playerAry = combatDetailTeam[i]
          for (let j = 0; j < playerAry.length; j++) {
            let cp = playerAry[j]
            if (cp && cp.cardId === player.cardId) {
              playerAry[j] = null
              this.choiceCombatTeamIndex = i
              break
            }
          }
        }
      }
    },
    // 重新计算队伍下标
    resetChoiceCombatTeamIndex () {
      this.choiceCombatTeamIndex = 0
      let team = this.choiceCombatDetail['team'] || []
      for (let i = 0; i < team.length; i++) {
        let players = team[i] || []
        for (let j = 0; j < players.length; j++) {
          if (players[j] == null) {
            this.choiceCombatTeamIndex = i
            return
          }
        }
      }
      if (team.length > 0) {
        this.choiceCombatTeamIndex = team.length
      }
    },
    getToDownPlayers () {
      let toDownPlayers = []
      this.choiceCombatDetail['upChoicePlayerIndex'].forEach(pIndex => {
        toDownPlayers.push(this.choicedPlayers[pIndex])
      })
      return toDownPlayers
    },
    downChoicePlayer (player) {
      if (player['checked'] === true) {
        player['checked'] = false
      } else {
        player['checked'] = true
      }
    },
    // 点击项目
    clickCombatDetail (combatDetail) {
      this.choiceCombatDetail = combatDetail
      // if (this.choiceCombatDetail['upChoicePlayerIndex'] == undefined) {
      //   this.upChoicePlayerIndex = []
      // } else {
      //   this.upChoicePlayerIndex = this.choiceCombatDetail['upChoicePlayerIndex']
      // }
      this.upChoicePlayerIndex = this.choiceCombatDetail['upChoicePlayerIndex'] || []
      this.upChoicePlayerCardId = this.choiceCombatDetail['upChoicePlayerCardId'] || []
      this.resetChoiceCombatTeamIndex()
    },
    // 将上面选择的队员信息拷贝到下方项目队员区域
    toDown () {
      let toDownPlayers = this.getToDownPlayers()
      if (toDownPlayers == null || toDownPlayers.length == 0) {
        this.$message.error('请选择要参赛的队员')
        return
      }
      if (this.choiceCombatDetail == null) {
        this.$message.error('请选择要参赛的项目')
        return
      }
      this.choiceCombatDetail['players'] = toDownPlayers
      this.choiceCombatDetail['upChoicePlayerIndex'] = this.upChoicePlayerIndex
      this.$forceUpdate()
    },
    // 点击项目时构建项目提示信息
    getCombatDetailAlert () {
      let identity = this.choiceCombatDetail.identity
      let minAge = this.choiceCombatDetail.minAge
      let maxAge = this.choiceCombatDetail.maxAge
      let minNumber = this.choiceCombatDetail.minNumber
      let maxNumber = this.choiceCombatDetail.maxNumber
      let sex = this.choiceCombatDetail.sex
      let youngMinAge = this.choiceCombatDetail.youndData.youngMinAge
      let youngMaxAge = this.choiceCombatDetail.youndData.youndMaxAge
      let youngSex = this.choiceCombatDetail.youndData.youngSex
      let youngNum = this.choiceCombatDetail.youndData.youngNum
      return '该项目队员年龄范围：' + matchFun.formatDate(minAge) + ' ~ ' + matchFun.formatDate(maxAge) +
        ' | 性别：' + (sex === 0 ? '无限制' : (sex === 1 ? '男' : '女')) + ((identity !== 1 && identity !== 2) ? (' | 每组人数限制：' + (minNumber === maxNumber ? minNumber + '人' : minNumber + ' ~ ' + maxNumber + '人')) : '') +
        (youngMinAge == null ? '' : (' | 允许小打大，小年龄范围：' + matchFun.formatDate(youngMinAge) + '~' + matchFun.formatDate(youngMaxAge) +
          ' | 性别：' + (youngSex === 0 ? '无限制' : (youngSex === 1 ? '男' : '女')) +
          ' | 人数：' + youngNum + ' 人'))
    },
    // 点击队伍
    teamClick (teamIndex) {
      this.choiceCombatTeamIndex = teamIndex
    },
    // 获取动态样式
    getTopSpanStyle (type) {
      let style = { width: '0%' }
      let color = this.getTopSpanBorderColor(type)
      if (this.choiceCombatDetail == null) {
        return ''
      } else {
        let sex = this.choiceCombatDetail.sex // 获取项目性别
        let youngSex = this.choiceCombatDetail.youndData.youngSex
        // 不分性别
        if (sex === 0) {
          // 有小打大
          if (youngSex != null) {
            style = { width: '33.3%', border: '2px solid ' + color + '', paddingTop: '10px' }
          } else {
            style = { width: '50%', border: '2px solid ' + color + '', paddingTop: '10px' }
          }
        } else if (sex === 1 || sex === 2) {
          // 男
          if (youngSex != null) {
            style = { width: '50%', border: '2px solid ' + color + '', paddingTop: '10px' }
          } else {
            style = { width: '100%' }
          }
        }
      }
      return style
    },
    // 获取动态样式
    getTopSpanBorderColor (type) {
      switch (type) {
        case 'boy':
          return 'dodgerblue'
        case 'girl':
          return 'pink'
        case 'young':
          return 'darkseagreen'
      }
    },
    addShow (item) {
      let teams = item['team'] || []
      return (item.minNumber != item.maxNumber && teams.length < item.teamLimit && teams.length > 0)
    },
    // 添加小队
    addTeam (item) {
      // 团队最大人数
      let maxNumber = item.maxNumber
      // 创建一个以最大人数为size的空数组
      let emptyPlayer = []
      for (let i = 0; i < maxNumber; i++) {
        emptyPlayer.push(null)
      }
      let team = item['team'] || []
      team.push(emptyPlayer)
      this.$forceUpdate()
    },
    // 查询项目兼项配置情况
    queryCombatTerm () {
      this.$api.match.combatTermList(this.matchId).then(res => {
        if (res.status === 0) {
          this.combatTerm = res.data || []
        }
      }).catch(err => {
        console.log('err', err)
      })
    },
    // 验证项目兼项情况
    verifyCombatTerm (player) {
      debugger
      // 获得队员id
      let cardId = player.cardId
      // 判断当前选择的项目是否有兼项配置
      let curCombatId = this.choiceCombatDetail.combatId
      for (let i = 0; i < this.combatTerm.length; i++) {
        console.log(curCombatId)
        let term = this.combatTerm[i]
        let projects = JSON.parse(term.project)
        let num = term.num // 可以选择的个数
        if (projects.indexOf(curCombatId) > -1) {
          // 含有该项目的配置
          let hasChoicedNum = 0 // 当前已经选择的个数
          let hasChoicedCombatName = '' // 当前已经选择的项目名称
          for (let j = 0; j < this.combatDetails.length; j++) {
            let combat = this.combatDetails[j]
            let combatId = combat.combatId
            if (projects.indexOf(combatId) > -1) {
              let identity = combat.identity
              if (identity > 2) {
                let team = combat['team'] || []
                for (let k = 0; k < team.length; k++) {
                  let players = team[k] || []
                  for (let m = 0; m < players.length; m++) {
                    let p = players[m]
                    if (p != null && p.cardId === cardId) {
                      hasChoicedNum++
                      hasChoicedCombatName += '[' + combat.fullName + ']'
                      if (hasChoicedNum >= num) {
                        this.$message.error('该队员已经选择了：' + hasChoicedCombatName + '不能继续报名该项目')
                        return false
                      }
                    }
                  }
                }
              } else {
                let players = combat['players'] || []
                for (let m = 0; m < players.length; m++) {
                  let p = players[m]
                  if (p != null && p.cardId === cardId) {
                    hasChoicedNum++
                    hasChoicedCombatName += '[' + combat.fullName + ']'
                    if (hasChoicedNum >= num) {
                      this.$message.error('该队员已经选择了：' + hasChoicedCombatName + '不能继续报名该项目')
                      return false
                    }
                  }
                }
              }
            }
          }
        }
      }
      return true
    },
    // 提交数据
    submit () {
      let params = {
        matchId: this.matchId,
        agencyId: this.$route.query.agencyId,
        teamId: this.$route.query.teamId,
        joinLeaderStaffs: this.coachId,
        combats: []
      }
      let hasPlayer = false // 是否选择了参赛队员
      for (let i = 0; i < this.combatDetails.length; i++) {
        let combatDetail = this.combatDetails[i]
        let identity = combatDetail.identity
        if (identity > 2) {
          let minNumber = combatDetail.minNumber
          let maxNumber = combatDetail.maxNumber

          // 团体项目
          let teams = combatDetail['team'] || []
          // 该项目原来是否有报名参赛的信息
          let hasSignData = combatDetail['hasSignData'] || false
          if (hasSignData) {
            hasPlayer = true
          }
          if (teams.length > 0 || hasSignData) {
            let combat = {
              combatId: combatDetail.combatId,
              combatDetailId: combatDetail.combatDetailId,
              fullName: combatDetail.fullName,
              identity: combatDetail.identity,
              minNumber: combatDetail.minNumber,
              maxNumber: combatDetail.maxNumber,
              teams: []
            }
            for (let j = 0; j < teams.length; j++) {
              let players = teams[j] || []
              let team = {
                teamNumber: j + 1,
                players: []
              }
              // 循环队员
              players.forEach(p => {
                if (p != null) {
                  team.players.push({
                    cardId: p.cardId,
                    sex: p.sex,
                    name: p.name,
                    enclosure: null,
                    type: p.type
                  })
                }
              })
              let len = team.players.length
              if (len > 0) {
                if (len < minNumber) {
                  this.$message.error(combatDetail.fullName + '参赛人数不能少于' + minNumber + '人')
                  return
                } else if (len > maxNumber) {
                  this.$message.error(combatDetail.fullName + '参赛人数不能多于' + maxNumber + '人')
                  return
                }
                combat.teams.push(team)
              }
            }
            hasPlayer = true
            params.combats.push(combat)
          }
        } else {
          // 个人项目
          let players = combatDetail['players'] || []
          // 该项目原来是否有报名参赛的信息
          let hasSignData = combatDetail['hasSignData'] || false
          if (hasSignData) {
            hasPlayer = true
          }
          if (players.length > 0 || hasSignData) {
            hasPlayer = true
            let combat = {
              combatId: combatDetail.combatId,
              combatDetailId: combatDetail.combatDetailId,
              fullName: combatDetail.fullName,
              identity: combatDetail.identity,
              minNumber: combatDetail.minNumber,
              maxNumber: combatDetail.maxNumber,
              teams: []
            }
            let team = {
              teamNumber: 0,
              players: []
            }
            players.forEach(p => {
              let player = {
                cardId: p.cardId,
                sex: p.sex,
                name: p.name,
                enclosure: null,
                type: p.type
              }
              team.players.push(player)
            })
            combat.teams.push(team)
            params.combats.push(combat)
          }
        }
      }
      if (!hasPlayer) {
        this.$message.error('请选择参赛队员')
        return
      }
      this.checkEnclosureSmallball(params)
    },
    checkEnclosureSmallball (data) {
      this.loading = true
      this.$api.join.checkEnclosureSmallball(data).then(res => {
        if (res.status === 0) {
          let players = res.data.players
          if (players.length > 0) {
            this.$refs.addEnclosure.show(res.data, data)
          } else {
            this.postData(data)
          }
        }
      }).finally(() => {
        this.loading = false
      })
    },
    enclosureSuccess (joinData) {
      this.postData(joinData)
    },
    jump (joinData) {
      this.postData(joinData)
    },
    // 发送提交请求
    postData (data) {
      this.loading = true
      this.$api.join.joinSmallball11(data).then(res => {
        if (res.status === 0) {
          this.$message.success('报名数据提交成功')
          this.$emit('success')
        } else {
          this.$message.error(res.msg)
        }
      }).catch(err => {
        console.log(err)
        this.$message.error('报名数据提交失败，请稍后重试')
      }).finally(_ => {
        this.loading = false
      })
    }
  },
  watch: {
    combatDetailGroup (newValue, oldValue) {
      if (newValue == null) {
        this.combatDetails = []
      } else {
        this.queryCombatDetailNameByTitle()
        // 查询兼项配置
        this.queryCombatTerm()
      }
    },
    choicedPlayers (newValue, oldValue) {
      let choicedPlayerIds = []
      if (newValue != null) {
        newValue.forEach(item => {
          choicedPlayerIds.push(item.cardId)
        })
      }
      store.commit('join/JOIN_ALL_CHOICED_CARD_IDS', this.choicedPlayerIds)
    }
  }
}
</script>
<style lang="scss" scoped>
  .title {
    font-size: 19px;
    font-weight: bold;
  }
  .sticky {
    top: 0;
    left: 0;
    z-index: 999;
    position: sticky;
  }
  .playerDiv {
    width: 100%;
    max-height: 300px;
    background-color: #fff;
    color: black;
    border: 1px solid #dbdbdb;
    padding: 10px;
    display: table;
    overflow: auto;
    span {
      display: table-cell;
      span {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
      }
    }
    .player {
      width: 60px;
      height: 110px;
      text-align: center;
      position: relative;
      margin-left: 20px;
      cursor:pointer;
      .head {
        height: 80px;
        width: 60px;
      }
      .checked {
        position: absolute;
        top: 0px;
        left: 0px;
        height: 80px;
        width: 60px;
      }
      p {
        cursor:pointer;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  .opertaionDiv {
    background-color: #fff;
    text-align: center;
    /*height: 60px;*/
    min-height: 20px;
    width: 100%;
    padding-top: 8px;
    .arrow {
      cursor:pointer;
    }
    .up {
      transform: rotate(180deg);
    }
    .margin10 {
      margin: 0px 10px 0px 10px;
    }
  }
  .combatDiv {
    width: 100%;
    background-color: #fff;
    color: black;
    border: 1px solid #dbdbdb;
    padding: 20px;
    overflow: auto;
    .btnContent {
      text-align: center;
      .btn{
        color: #fff;
        width: 100px;
        height: 30px;
        line-height: 30px;
        margin: 0 auto;
        right: 250px;
        text-align: center;
        border-radius: 2px;
        background-color: #b80000;
        cursor:pointer;
        margin-top: 20px;
      }
    }
    .leftCell {
      display: table-cell;
      width: 120px;
      vertical-align: top;
      cursor:pointer;
      .combatName {
        color: white;
        padding: 5px 12px 5px 12px;
        border-radius: 5px;
        margin-right: 20px;
        text-align: center;
      }
      .default {
        background-color: #a7a3a3;
      }
      .active {
        background-color: #b80000;
      }
    }
    .rightCell {
      display: table-cell;
      vertical-align: top;
      .playerContainer {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        min-height: 80px;
        .player {
          position: relative;
          text-align: center;
          margin-left: 20px;
          .add {
            color: gray;
          }
          .waiting {
            color: gray;
          }
          .head {
            height: 80px;
            width: 60px;
            border-radius: 5px;
          }
          .checked {
            position: absolute;
            top: 0px;
            left: 0px;
            height: 80px;
            width: 60px;
            border-radius: 5px;
          }
          p {
            cursor:pointer;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        .left20 {
          margin-left: 20px;
        }
        .teamContainer {
          display: flex;
          flex-wrap: wrap;
          padding: 10px;
          background-color: rgb(247, 247, 247);
          border-radius: 5px;
          margin-bottom: 1rem;
        }
        .curTeam {
          background-color: rgb(153, 217, 234);
        }
        .left10 {
          margin-left: 10px;
        }
        .teamPlayer {
          position: relative;
          text-align: center;
          .head {
            height: 80px;
            width: 60px;
            border-radius: 5px;
          }
          .checked {
            position: absolute;
            top: 0px;
            left: 0px;
            height: 80px;
            width: 60px;
            border-radius: 5px;
          }
          p {
            cursor:pointer;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            margin-bottom: 0px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/comm/components/join/smallBall/StepThreeJoinCombatDetail.vue